import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import axios from "axios";
import config from "@/config";

Vue.use(VueLocalStorage);

axios.defaults.baseURL = config.host;

/**
 * 网络请求异常处理
 * @param {*} error
 * @param {*} reject
 */
const responseError = (error, reject) => {
  reject({
    ret: false,
    data: '',
    msg: "Error！",
  });
};

/**
 * 请求成功处理
 * @param {*} response
 * @param {*} resolve
 * @param {*} reject
 */
const responseSuccess = (response, resolve, reject) => {
  const data = response.data;
  if (data.ret) {
    resolve(data.data);
  } else {
    reject(data);
  }
};

/**
 * @desc 获取get请求
 * @param {*} url
 * @param {*} params
 */
export const reqPost = (url, params = {}) => {
  let headers = {
    "Content-Type": "application/json",
  };
  headers.token = Vue.localStorage.get("token");
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      headers: headers,
      data: params,
      method: "post",
    })
      .then((res) => responseSuccess(res, resolve, reject))
      .catch((error) => responseError(error, reject));
  });
};

/**
 * @desc 文件上传
 * @param {*} url
 * @param {*} formData
 */
export const reqUpload = (url, formData) => {
  let headers = {
    'Content-Type': 'multipart/form-data'
  }
  headers.token = Vue.localStorage.get("token");
  let params = {
    url: url,
    method: 'POST',
    headers: headers,
    data: formData
  }
  return new Promise((resolve, reject) => {
    axios(params)
      .then(res => responseSuccess(res, resolve, reject))
      .catch(error => responseError(error))
  })
}